// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'offer';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.562 10.688v6.75m0-1.125h11.25a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25-2.25H.562m3.938 2.25h2.25M9.555 3.656a3.094 3.094 0 1 0 6.188 0 3.094 3.094 0 0 0-6.188 0zm7.867 7.594a5.064 5.064 0 0 0-9.547 0'
  />
);

export const viewBox = '0 0 18 18';
